module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logDetro) ? _c('div', {
    staticClass: "detro-container m-b"
  }, [_c('div', {
    staticClass: "shell-wrap"
  }, [_c('p', {
    staticClass: "shell-top-bar"
  }, [_vm._v("Serviço de Comunicação com o Detro")]), _vm._v(" "), _c('div', {
    staticClass: "shell-body"
  }, [_c('table', {
    staticClass: "table"
  }, _vm._l((_vm.getDetroTasks), function(task) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(task.name))]), _vm._v(" "), (task.checkFcn) ? _c('td', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.mostraLog(task.log)
        }
      }
    }, [_c('strong', [_vm._v("Ok")]), _vm._v(" "), _c('span', {
      staticClass: "font-thin"
    }, [_vm._v("\n                    " + _vm._s(_vm.moment(task.date).format('L')) + " " + _vm._s(_vm.moment(task.date).format('LTS')) + "\n                  ")])])]) : _c('td', [_c('strong', {
      staticClass: "text-danger"
    }, [_vm._v("Não executado")]), _vm._v(" "), (Array.isArray(task.attemp) ? task.attemp.length : task.attemp) ? _c('button', {
      staticClass: "btn btn-xs btn-danger text-white",
      staticStyle: {
        "font-family": "arial"
      },
      on: {
        "click": function($event) {
          return _vm.mostraLog(task.log)
        }
      }
    }, [_vm._v("Tentativas falhas\n            ")]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [(_vm.allDetroLogs) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.mostraLog(_vm.allDetroLogs)
      }
    }
  }, [_vm._v("Existem "), _c('strong', [_vm._v(_vm._s(_vm.allDetroLogs.length) + " logs")]), _vm._v(" no sistema para esta GRV. Clique para visualizar")]) : _vm._e()])])]), _vm._v(" "), (_vm.showLog) ? _c('div', {
    staticClass: "shell-wrap window"
  }, [_c('div', {
    staticClass: "shell-top-bar"
  }, [_c('a', {
    staticClass: "mclose",
    on: {
      "click": function($event) {
        _vm.showLog = false
      }
    }
  }, [_vm._v("x")]), _vm._v("\n      Serviço de Comunicação com o Detro\n    ")]), _vm._v(" "), _c('pre', {
    staticClass: "shell-body"
  }, [_vm._v(_vm._s(_vm.logContent))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335d73b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/LogDetroGrvPatio.vue
// module id = 1585
// module chunks = 17